import { styled, Table } from "@mui/material";

export const StyledTable = styled(Table)(({ theme }) => ({
  th: {
    padding: "4px",
    lineHeight: "18px",
    fontWeight: 700,
  },
  td: {
    backgroundColor: theme.palette.background.paper,
    padding: "4px",
  },
}));
